import { JSX, useMemo } from "react";

import { Box, Paper, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSummarizedHistoryChartQuery } from "src/api/locationChartQueries.api";
import DifferenceChip from "src/components/Difference/DifferenceChip";
import IntervalType from "src/constants/intervalType.enum";
import MeasureType from "src/constants/measureType.enum";
import sharedStyles from "src/constants/styles";
import { TIME_GRANULARITY } from "src/lib/config.helper";
import { formatNum, getCurrentTotalCount, getDifference } from "src/lib/number.helpers";
import { type MeasuresSummarizedDto } from "src/types/dashboardDatasetDto";

import DashboardBlockLineChart from "./chart/DashboardBlockLineChart";
import getStyles from "./helper/infoBar.helper";
import { type DashboardComponentParams } from "../interfaces/DashboardComponentParams";

function VisitorsNowComponent({ selectedLocation }: DashboardComponentParams): JSX.Element {
  const { t } = useTranslation();
  const theme = useTheme();

  const { data: measuresData } = useSummarizedHistoryChartQuery(
    [selectedLocation.Id],
    IntervalType.Hour,
    null,
    MeasureType.Occupancy,
    null,
    TIME_GRANULARITY,
    false,
    true
  );

  const filteredMeasuresData: MeasuresSummarizedDto | undefined = useMemo(() => {
    if (!measuresData) return undefined;
    return { ...measuresData, data: measuresData.data.filter((i) => i.locationId === selectedLocation.Id) };
  }, [measuresData, selectedLocation.Id]);

  const currentPeriodSum = useMemo(() => getCurrentTotalCount(filteredMeasuresData?.data ?? []), [filteredMeasuresData]);
  const diff = useMemo(() => getDifference(filteredMeasuresData), [filteredMeasuresData]);

  return (
    <Paper sx={getStyles(theme).fullheight}>
      <Box sx={getStyles(theme).innerBox}>
        <Box sx={getStyles(theme).titleBox}>
          <Typography
            color={theme.palette.text.secondary}
            fontSize={theme.fontSizes.sm}
            fontWeight={theme.typography.fontWeightRegular}
            textTransform='uppercase'
          >
            {t("Visitors Now")}
          </Typography>
        </Box>
        <Box sx={sharedStyles(theme).centerFlexbox}>
          <Typography variant='h2'>{formatNum(currentPeriodSum ?? 0)}</Typography>
          <DifferenceChip difference={diff} fontSize={theme.fontSizes.md} />
        </Box>
        {/* <Box sx={sharedStyles(theme).centerFlexbox}>
          <Box sx={getStyles(theme).iconBox}>
            <AutoFixHigh fontSize='inherit' />
          </Box>
          <Typography sx={getStyles(theme).insightText}>
            {t("Busiest time today expected from")} <strong>{t("12 PM-15 PM")}</strong>
          </Typography>
        </Box> */}
      </Box>
      <DashboardBlockLineChart intervalType={IntervalType.Day} selectedLocation={selectedLocation} />
    </Paper>
  );
}

export default VisitorsNowComponent;
